import {useCallback} from "react";
import {useSelector} from "react-redux";

export function useTranslate() {
    const glossary = useSelector(state => state.app.dictionary);
    const translator = useSelector(state => state.app.config?.translate ?? false);

    return useCallback((label) => {
        if (!translator) return label;
        return glossary?.[label] || label;
    }, [glossary, translator]);
}
